import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { TemplatesModalComponent } from "./templates-modal.component";
import { AChartComponent } from "../../achart/achart.component";
import { MobileTemplatesModalComponent } from "../mobile-templates-modal/mobile-templates-modal.component";


export function ShowTemplatesModal(modalService: NgbModal, acharts: AChartComponent[], mobileMode = 'desktop'): Promise<any> {
    const mobile = mobileMode != 'desktop';
    const component = mobile? MobileTemplatesModalComponent: TemplatesModalComponent;
    const windowClass = "dark-modal" + (mobile? ' mobile': '');
    let m: NgbModalRef = modalService.open(component, {
        backdrop: "static",
        size: "lg",
        centered: true,
        windowClass: windowClass
    });
    let modal = (<TemplatesModalComponent>m.componentInstance);
    modal.acharts = acharts;
    return m.result;
}